import { useEditor } from "@craftjs/core";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import { GrigoraEditorContext } from "../context";
import { TextSettings } from "../../blocks/text/settings";
import SettingImage from "../../../assets/homepage/settings.png";
import {
  IconInput,
  MarginInput,
  Panel,
  SelectInput,
  Spacer,
  Tabs,
  TextInput,
  ToggleInput,
  UnitInput,
} from "../../input";
import { INPUT_LIMITS } from "../../input-limits";

const JoyrideComponent = () => {
  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing="1rem">
          <SelectInput
            resetValue={undefined}
            value={undefined}
            options={[
              {
                label: "Block",
                value: "block",
              },
              {
                label: "Inline",
                value: "inline",
              },
              {
                label: "Inline Block",
                value: "inline-block",
              },
            ]}
            label="Display"
          />
          <ToggleInput
            isResetVisible={false}
            label="Dynamic Link"
            value={undefined}
          />
          {false ? (
            <>
              <SelectInput
                isResetVisible={false}
                label="Link Src"
                value={undefined}
                options={[
                  {
                    label: "-",
                    value: "",
                  },
                  {
                    label: "Post Link",
                    value: "post-link",
                  },
                ]}
              />
            </>
          ) : (
            <>
              <TextInput
                minLength={INPUT_LIMITS["outbound-link"].minlength}
                maxLength={INPUT_LIMITS["outbound-link"].maxlength}
                resetValue={undefined}
                value={undefined}
                label={"Link"}
              />
            </>
          )}

          <ToggleInput
            resetValue={undefined}
            label="Open in new tab"
            value={undefined}
          />
          <ToggleInput
            resetValue={undefined}
            label="No Follow"
            value={undefined}
          />
          <ToggleInput
            resetValue={undefined}
            label="No Referrer"
            value={undefined}
          />
        </Spacer>
        <Panel
          id={`block-setting-${1}-dimension`}
          title={"Dimension"}
          initialOpen={true}
        >
          <UnitInput resetValue={undefined} value={undefined} label={"Width"} />
        </Panel>
        <Panel
          id={`block-setting-${3}-dimension`}
          title={"Layout"}
          initialOpen={true}
        >
          <MarginInput resetValue={undefined} label="Url" value={undefined} />
        </Panel>
      </div>
    );
  }

  function StyleSettings() {
    return <></>;
  }

  function AdvancedSettings() {
    return <></>;
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
    },
    {
      label: "Style",
      key: "style",
      children: StyleSettings(),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
    },
  ];
  return (
    <Tabs
      id={`block-settings-tab-${1}`}
      type="block-setting"
      items={tabs.map((item, i) => {
        return {
          label: item.label,
          key: item.key,
          children: item.children,
        };
      })}
    />
  );
};

export const SettingsPanel = ({ isJoyrideOpen }) => {
  const { setIsBlockSettingsVisible } = useContext(GrigoraEditorContext);

  const { selected, isEnabled } = useEditor((state, query) => {
    const currentNodeId = query.getEvent("selected").last();
    let selected;

    if (currentNodeId) {
      selected = {
        id: currentNodeId,
        name:
          state.nodes[currentNodeId].data.custom.displayName ||
          state.nodes[currentNodeId].data.displayName ||
          state.nodes[currentNodeId].data.name,
        settings:
          state.nodes[currentNodeId].related &&
          state.nodes[currentNodeId].related.settings,
        isDeletable: query.node(currentNodeId).isDeletable(),
      };
    }

    return {
      selected,
      isEnabled: state.options.enabled,
    };
  });

  return (
    <>
      <div
        id="settings-panel"
        className="box no-cursor w-full bg-white border-l border-gray-200 overflow-hidden z-[1001] flex flex-col "
      >
        {isJoyrideOpen ? (
          <div data-cy="settings-panel" className="">
            <JoyrideComponent />
          </div>
        ) : (
          <>
            <div className="block-settings__header h-[40px] flex w-full cursor-grab px-4 py-4">
              <div className="flex w-full select-none text-sm items-center text-center justify-between">
                <div className="text-[16px] font-medium">{selected?.name}</div>
                <div
                  onClick={(e) => {
                    setIsBlockSettingsVisible(false);
                  }}
                  className="p-1 cursor-pointer flex w-[20px] h-[20px] rounded-[2px] duration-300 items-center justify-center"
                >
                  <FontAwesomeIcon icon={faXmark} />
                </div>
              </div>
            </div>
            <div className="flex h-[calc(100%-40px)] flex-col text overflow-y-auto grigora-hidden-scrollbar">
              {isEnabled && selected ? (
                <div>
                  <div data-cy="settings-panel" className="">
                    {selected.settings &&
                      React.createElement(selected.settings)}
                  </div>
                </div>
              ) : (
                <div className="flex-1 flex flex-col w-full">
                  <div
                    data-cy="settings-panel"
                    className="text-gray-500 text-grigora-base italic m-auto text-center"
                  >
                    <div>
                      (Block Settings)
                      <br></br>
                      No Block Selected.
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};
